import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalizedDatePipe } from '@myshared/localized-date.pipe';
import { AiTariffService } from 'src/app/ai-tariff.service';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';

@Component({
  selector: 'app-ai-tariff-card',
  templateUrl: './ai-tariff-card.component.html',
  providers: [LocalizedDatePipe],
  standalone: false
})
export class AiTariffCardComponent {

  @Input() subscription: Subscription;
  @Input() isAdmin: boolean;

  constructor(
    private router: Router,
    private m: Model,
    private date: LocalizedDatePipe,
    private aiTariffService: AiTariffService) {
  }

  public get hasScheduledOrder(): boolean {
    return !!this.scheduledOrder;
  }

  public changeTariff() {
    if (this.hasScheduledOrder) return;
    this.router.navigate(['/do', ...this.roleSegment, 'change-ai-tariff', this.subscription.appliance_id, 'choose-ai-tariff']);
  }

  public cancelTariffOrder() {
    this.router.navigate(['/do', ...this.roleSegment, 'change-ai-tariff', this.subscription.appliance_id, 'order-cancel']);
  }

  private get roleSegment() {
    if (!this.subscription.is_my) {
      const user = this.m.account.currentUser;
      if (user.companyIsPC20Csp) return ['csp'];
      else if (user.companyIsPartner) return ['partner'];
    }
    return [];
  }

  get hasCurrentAITariffDetail(): boolean {
    return !!this.subscription?.ai_tariff?.name;
  }

  get currentTariffString() {
    const name = this.subscription?.ai_tariff?.name;
    if (!name) return '';
    return 'ai-tariff-card_pascom_ai_tariff_' + this.aiTariffService.getTariffIdentifier(name);
  }

  get scheduledTariffString() {
    const name = this.scheduledTariffOrderName;
    if (!name) return '';
    return 'ai-tariff-card_pascom_ai_tariff_' + this.aiTariffService.getTariffIdentifier(name);
  }

  get scheduledOrder() {
    return this.subscription?.scheduledAITariffOrder;
  }

  get scheduledTariffOrderName() {
    return this.scheduledOrder?.scheduledAITariffOrderLine?.product;
  }

  get scheduledTariffOrderDate() {
    return this.date.transform(this.scheduledOrder?.deliveryDate)
  }

}
